module.exports = __webpack_public_path__ + "static/media/bbq.699d9bef.png";